import { useMemo, useState, useEffect } from "react";
import { Toast } from "react-bootstrap";
import Select from "react-select";
import TableRelatoriosAcompanhamento from "../../Components/TableRelatoriosAcompanhamento";
import Api from "../../Auth/Api";
import * as XLSX from 'xlsx';

function Acompanhamento() {
    const token = JSON.parse(localStorage.getItem("user_token"));

    const [data, setDatas] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [filters, setFilters] = useState({
        dataInicio: '',
        dataFim: '',
        treinamento: null,
        unidade: null,
        statusExpiracao: null,
        statusProgresso: null,
        tipoCurso: null
    });
    const [hasFiltered, setHasFiltered] = useState(false);
    const [treinamentos, setTreinamentos] = useState([]);
    const [unidades, setUnidades] = useState([]);
    const [statusExpiracaoOptions] = useState([
        { value: 'expirados', label: 'Expirados' },
        { value: '30_dias', label: '30 Dias para Expirar' },
        { value: '60_dias', label: '60 Dias para Expirar' }
    ]);
    const [statusProgressoOptions] = useState([
        { value: 'nao_fez_teorica', label: 'Não fez a Teoria' },
        { value: 'nao_fez_avaliacao', label: 'Não fez Avaliação' },
        { value: 'nao_fez_pratica', label: 'Não fez a Prática' },
        { value: 'concluido', label: 'Concluído' }
    ]);
    const [tipoCursoOptions] = useState([
        { value: 'online', label: 'Online' },
        { value: 'misto', label: 'Híbrido' },
        { value: 'presencial', label: 'Presencial' }
    ]);
    const [verificarFiltro, setVerificarFiltro] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [toast, setToast] = useState({ header: '', body: '' });
    const [filtersExpanded, setFiltersExpanded] = useState(false);

    // Carregar treinamentos e unidades disponíveis
    useEffect(() => {
        async function fetchOptions() {
            try {
                const responseTreinamentos = await Api.get(`/api/show/treinamentos`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setTreinamentos(responseTreinamentos.data.map(t => ({ value: t.nome, label: t.nome })));

                const responseUnidades = await Api.get(`/api/show/unidades`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setUnidades(responseUnidades.data.map(u => ({ value: u.nome, label: u.nome })));
            } catch (error) {
                console.error("Erro ao carregar opções: ", error.response.data.message);
            }
        }
        fetchOptions();
    }, [token]);

    const handleInputChange = (name, value) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            [name]: value
        }));
        setVerificarFiltro(true);
        
    };


    const handleApplyFilters = async () => {
        // Validação das datas
        if (filters.dataInicio && filters.dataFim && filters.dataInicio > filters.dataFim) {
            setToast({ 
                header: 'Erro de Validação', 
                body: 'A data de início não pode ser maior que a data fim. Por favor, verifique as datas selecionadas.' 
            });
            setShowToast(true);
            return;
        }

        setLoading(true);
        try {
            const response = await Api.get(`api/relatorio/acompanhamento`, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
            params: {
                dataInicio: filters.dataInicio || undefined,
                dataFim: filters.dataFim || undefined,
                treinamento: filters.treinamento ? filters.treinamento.value : undefined,
                unidade: filters.unidade ? filters.unidade.value : undefined,
                statusExpiracao: filters.statusExpiracao ? filters.statusExpiracao.value : undefined,
                statusProgresso: filters.statusProgresso ? filters.statusProgresso.value : undefined,
                tipoCurso: filters.tipoCurso ? filters.tipoCurso.value : undefined,
            }
            });
            setDatas(response.data);
            setFilteredData(response.data);
            
            setHasFiltered(true);
            setLoading(false);
        } catch (error) {
            console.error("Erro ao aplicar filtros:", error.response.data.message);
        }
    };

    // Função para exportar para Excel
    const handleExportExcel = () => {
        // Usar os dados filtrados para exportação
        const dataToExport = filteredData.length > 0 ? filteredData : data;
        
        const dataForExcel = dataToExport.map(row => ({
            "Matrícula": row.matricula,
            "Nome do Colaborador": row.nome_colaborador,
            "Unidade": row.unidade,
            "Tópico/Módulo": row.nome_topico ? `${row.nome_topico} - ${row.nome_modulo}` : row.nome_modulo,
            "Tipo de Curso": row.tipo_curso ? row.tipo_curso.charAt(0).toUpperCase() + row.tipo_curso.slice(1) : '',
            "Status Teoria": row.status_teorica,
            "Data Teoria": row.data_ultima_aula,
            "Data Avaliação": row.data_avaliacao,
            "Nota de Avaliação": row.nota_avaliacao,
            "Data Prática": row.data_pratica || "-",
            "Data Avaliação de Reação": row.data_avaliacao_reacao || 'N/A',
            "Data de Emissão do Certificado": row.emissao_certificado || 'N/A',
            "Status Certificado": row.status_certificado,
            "Tempo para Expirar (dias)": row.dias_para_expirar
        }));

        // Cria uma nova planilha
        const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Relatório");

        // Gera um arquivo Excel e faz o download
        XLSX.writeFile(workbook, `relatorio_acompanhamento.xlsx`);
    };


    const columns = useMemo(
        () => [
            {
                Header: () => null,
                id: 'matricula',
                accessor: row => row.matricula,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex">
                        {original.matricula}
                    </div>
                )
            },
            {
                Header: () => null,
                id: 'nome_colaborador',
                accessor: row => row.nome_colaborador,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex">
                        {original.nome_colaborador}
                    </div>
                )
            },
            {
                Header: () => null,
                id: 'unidade',
                accessor: row => row.unidade,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex">
                        {original.unidade}
                    </div>
                )
            },
            {
                Header: () => null,
                id: 'topico_modulo',
                accessor: row => row.nome_modulo,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex flex-column">
                        {original.nome_topico && (
                            <small className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>
                                {original.nome_topico}
                            </small>
                        )}
                        <span 
                            title={original.nome_modulo}
                            style={{ cursor: 'help' }}
                        >
                            {original.nome_modulo && original.nome_modulo.length > 50 
                                ? original.nome_modulo.substring(0, 50) + '...'
                                : original.nome_modulo
                            }
                        </span>
                    </div>
                )
            },
            {
                Header: () => null,
                id: 'tipo_curso',
                accessor: row => row.tipo_curso,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex text-capitalize">
                        {original.tipo_curso}
                    </div>
                )
            },
            {
                Header: () => null,
                id: 'status_teorica',
                accessor: row => row.status_teorica,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex">
                        {original.status_teorica}
                    </div>
                )
            },
            {
                Header: () => null,
                id: 'data_ultima_aula',
                accessor: row => row.data_ultima_aula,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex">
                        {original.data_ultima_aula}
                    </div>
                )
            },
            {
                Header: () => null,
                id: 'data_avaliacao',
                accessor: row => row.data_avaliacao,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex">
                        {original.data_avaliacao}
                    </div>
                )
            },
            {
                Header: () => null,
                id: 'nota_avaliacao',
                accessor: row => row.nota_avaliacao,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex text-center justify-content-center">
                        {original.nota_avaliacao}
                    </div>
                )
            },
            {
                Header: () => null,
                id: 'data_pratica',
                accessor: row => row.data_pratica,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex">
                        {original.data_pratica}
                    </div>
                )
            },
            {
                Header: () => null,
                id: 'data_avaliacao_reacao',
                accessor: row => row.data_avaliacao_reacao,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex">
                        {original.data_avaliacao_reacao}
                    </div>
                )
            },
            {
                Header: () => null,
                id: 'emissao_certificado',
                accessor: row => row.emissao_certificado,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex">
                        {original.emissao_certificado || 'N/A'}
                    </div>
                )
            },
            {
                Header: () => null,
                id: 'status_certificado',
                accessor: row => row.status_certificado,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex">
                        {original.status_certificado === 'Expirado' ?
                            <span className="badge bg-danger">{original.status_certificado}</span> :
                            original.status_certificado === 'N/A' ?
                                original.status_certificado :
                                <span className="badge bg-success">{original.status_certificado}</span>
                        }
                    </div>
                )
            },
            {
                Header: () => null,
                id: 'dias_para_expirar',
                accessor: row => row.dias_para_expirar,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex">
                        {original.dias_para_expirar === 'N/A' ?
                            'N/A' :
                            <>
                                {parseInt(original.dias_para_expirar) <= 0 ?
                                    <span className="badge bg-danger">Expirado</span> :
                                    <span className="badge bg-warning text-dark">{original.dias_para_expirar} dias</span>
                                }
                            </>
                        }
                    </div>
                )
            },

        ],
        []
    );

    const customStyles = {
        container: (base) => ({
            ...base,
            width: '100%',
        }),
        control: (base, state) => ({
            ...base,
            fontSize: "1rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.25rem",
            boxShadow: state.isFocused ? "0 0 0 0.25rem #27485b73" : null,
            borderColor: "#dee2e6",
            "&:hover": {
                borderColor: "#dee2e6"
            },
        }),
        singleValue: (base) => ({
            ...base,
            color: '#000',
            marginTop: '5px',
        }),
        input: (base) => ({
            ...base,
            height: "46px",
            margin: '0px',
            padding: '0px !important',

        }),
        menu: (base) => ({
            ...base,
            backgroundColor: '#fff',
            zIndex: 9999,
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
        option: (base, state) => ({
            ...base,
            color: state.isSelected ? '#3a5a6c' : null,
            backgroundColor: state.isFocused ? '#27485b73' : null,
            "&:active": {
                backgroundColor: "#27485b73"
            },
        }),
    };

    return (
        <>
            <div className="fade-in w-100 mt-3" style={{ marginBottom: '100px' }}>
                <span className="text-primary fs-1">Relatório de Acompanhamento</span>
                <p className="fs-6">Gere e consulte relatórios detalhados sobre o progresso dos usuários, aulas concluídas e certificados emitidos.</p>

                {/* Filtros */}
                <div className="filters mb-4 rounded" style={{ backgroundColor: '#ffffff', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                    {/* Cabeçalho dos Filtros */}
                    <div 
                        className="d-flex justify-content-between align-items-center p-3 border-bottom cursor-pointer"
                        onClick={() => setFiltersExpanded(!filtersExpanded)}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="d-flex align-items-center">
                            <i className="bi bi-funnel me-2 text-primary"></i>
                            <h6 className="mb-0 text-primary fw-bold">Filtros de Busca</h6>
                        </div>
                        <i className={`bi ${filtersExpanded ? 'bi-chevron-up' : 'bi-chevron-down'} text-primary fs-5`}></i>
                    </div>

                    {/* Conteúdo dos Filtros */}
                    <div 
                        className="overflow-hidden"
                        style={{
                            maxHeight: filtersExpanded ? '1000px' : '0px',
                            opacity: filtersExpanded ? 1 : 0,
                            transition: 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out'
                        }}
                    >
                        <div className="p-4">
                            {/* Primeira linha - Treinamento, Unidade, Datas e Tipo */}
                            <div className="row g-3 mb-3">
                                <div className="col-12 col-md-6 col-lg-5">
                                    <label htmlFor="treinamento">Treinamento</label>
                                    <Select
                                        name="treinamento"
                                        options={treinamentos}
                                        styles={customStyles}
                                        classNamePrefix="select"
                                        placeholder="Selecione um Treinamento"
                                        value={filters.treinamento}
                                        onChange={value => handleInputChange('treinamento', value)}
                                        isClearable
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                    <label htmlFor="unidade">Unidade</label>
                                    <Select
                                        name="unidade"
                                        options={unidades}
                                        styles={customStyles}
                                        classNamePrefix="select"
                                        placeholder="Selecione uma Unidade"
                                        value={filters.unidade}
                                        onChange={value => handleInputChange('unidade', value)}
                                        isClearable
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                                <div className="col-12 col-md-6 col-lg-2">
                                    <label htmlFor="dataInicio">Data Início</label>
                                    <input
                                        type="date"
                                        name="dataInicio"
                                        className="form-control"
                                        value={filters.dataInicio}
                                        onChange={e => handleInputChange('dataInicio', e.target.value)}
                                    />
                                </div>
                                <div className="col-12 col-md-6 col-lg-2">
                                    <label htmlFor="dataFim">Data Fim</label>
                                    <input
                                        type="date"
                                        name="dataFim"
                                        className="form-control"
                                        value={filters.dataFim}
                                        onChange={e => handleInputChange('dataFim', e.target.value)}
                                    />
                                </div>
                            </div>
                            
                            {/* Segunda linha - Status e Tipo de Curso */}
                            <div className="row g-3">
                                <div className="col-12 col-md-6 col-lg-3">
                                    <label htmlFor="statusExpiracao">Status de Expiração</label>
                                    <Select
                                        name="statusExpiracao"
                                        options={statusExpiracaoOptions}
                                        styles={customStyles}
                                        classNamePrefix="select"
                                        placeholder="Selecione Status"
                                        value={filters.statusExpiracao}
                                        onChange={value => handleInputChange('statusExpiracao', value)}
                                        isClearable
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                    <label htmlFor="statusProgresso">Status de Progresso</label>
                                    <Select
                                        name="statusProgresso"
                                        options={statusProgressoOptions}
                                        styles={customStyles}
                                        classNamePrefix="select"
                                        placeholder="Selecione Status"
                                        value={filters.statusProgresso}
                                        onChange={value => handleInputChange('statusProgresso', value)}
                                        isClearable
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                    <label htmlFor="tipoCurso">Tipo de Curso</label>
                                    <Select
                                        name="tipoCurso"
                                        options={tipoCursoOptions}
                                        styles={customStyles}
                                        classNamePrefix="select"
                                        placeholder="Selecione o Tipo"
                                        value={filters.tipoCurso}
                                        onChange={value => handleInputChange('tipoCurso', value)}
                                        isClearable
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3 d-flex align-items-end">
                                    <div className="d-flex gap-2 w-100">
                                        <button className={`btn btn-primary flex-fill ${!verificarFiltro ? 'disabled cursor-disabled' : ''}`} disabled={!verificarFiltro} onClick={handleApplyFilters}>
                                            Aplicar Filtros
                                        </button>
                                        <button className={`btn btn-secondary flex-fill ${!hasFiltered ? 'disabled cursor-disabled' : ''}`} disabled={!hasFiltered} onClick={handleExportExcel}>
                                            <i className="bi bi-table"></i> | Baixa Excel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {loading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Carregando...</span>
                        </div>
                    </div>
                ) : (
                    /* Tabela - só exibe após aplicar os filtros e quando não está carregando */
                    hasFiltered && (
                        <TableRelatoriosAcompanhamento titulo="Relatórios em grupo" columns={columns} data={filteredData} />
                    )
                )}
            </div>

            <Toast show={showToast} onClose={() => setShowToast(false)} delay={5000} autohide style={{ position: 'fixed', left: '95%', bottom: '10px', transform: 'translateX(-95%)', zIndex: 9999 }}>
                <Toast.Header>
                    <strong className="me-auto text-danger">{toast.header}</strong>
                </Toast.Header>
                <Toast.Body>{toast.body}</Toast.Body>
            </Toast>
        </>
    );
}

export default Acompanhamento;
